import { campaignsConstants } from '@constants/campaigns';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { campaignsService } from '@services';

function request() {
    return { type: campaignsConstants.CAMPAIGNS_FETCH };
}

function success(data) {
    return { type: campaignsConstants.CAMPAIGNS_SUCCESS, data };
}

function failure(message) {
    return { type: campaignsConstants.CAMPAIGNS_ERROR, message };
}

const get = (page = 0, pageSize = DEFAULT_PAGE_SIZE) => {
    return dispatch => {
        dispatch(request());
        campaignsService.get(page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

const setCampaigns = data => {
    return { type: campaignsConstants.SET_CAMPAIGNS, data };
};

export const campaignsActions = {
    get,
    setCampaigns,
};
